<template>
  <rect x="10" y="8" width="24" height="5" rx="2.5" fill="#5B5B5B" />
  <rect x="10" y="17" width="46" height="20" rx="3" fill="#5B5B5B" />
</template>
